import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { groupGalleryItemsByDate } from '@/pages/ipe/workbench/utils/groupGalleryByDate';

function resolveItemId(item) {
  return item?.id ?? item;
}

export default function LibraryModalDateGroupedGrid({
  items = [],
  footer = null,
  renderItem,
  className = '',
  isItemSelected,
  onToggleDateGroup,
}) {
  const { t } = useTranslation('workbench');
  const dateGroups = useMemo(() => groupGalleryItemsByDate(items), [items]);
  const checkSelected = typeof isItemSelected === 'function'
    ? isItemSelected
    : () => false;

  if (dateGroups.length === 0) return null;

  return (
    <div
      className={`funding-library-modal__grid funding-library-modal__grid--flex funding-library-modal__grid--by-date${className ? ` ${className}` : ''}`}
    >
      {dateGroups.map((group) => {
        const groupIds = group.items.map((item) => resolveItemId(item)).filter(Boolean);
        const selectedInGroup = groupIds.filter((id) => checkSelected({ id })).length;
        const allGroupSelected = groupIds.length > 0 && selectedInGroup === groupIds.length;
        const someGroupSelected = selectedInGroup > 0 && !allGroupSelected;

        return (
          <section key={group.dateKey} className="funding-library-modal__date-group">
            <label className="funding-library-modal__date-group-title">
              <input
                type="checkbox"
                className="funding-library-modal__date-group-checkbox"
                checked={allGroupSelected}
                ref={(node) => {
                  if (node) node.indeterminate = someGroupSelected;
                }}
                onChange={() => onToggleDateGroup?.(group.items)}
                aria-label={t('spaceBoard.selectDateGroup', { label: group.label })}
              />
              <span className="funding-library-modal__date-group-label">{group.label}</span>
              <span className="funding-library-modal__date-group-count">{t('upload.countImages', { count: group.items.length })}</span>
            </label>
            <div className="funding-library-modal__date-group-grid">
              {group.items.map((item) => renderItem(item))}
            </div>
          </section>
        );
      })}
      {footer}
    </div>
  );
}
